import { useUIConfigurationContext } from './uiConfigurationContext';
import { Configuration } from './model';

export const useUIConfiguration = <
  K extends keyof Configuration,
  P extends keyof Configuration[K],
>(
  component: K,
  property: P,
): Configuration[K][P] => {
  const configuration = useUIConfigurationContext();

  return configuration[component][property];
};
